import { StructureObjectDto as StructureObjectDtoOld } from '@/endpoints/models'
import { StructureObjectDto } from '@/rtkApi/mddApiSliceGenerated'
import { diagramUpdated } from '@/store'
import {
	initApiCollection,
	saveApiCollection,
	updateApiCollection,
} from '@/store/modules/apiCollection/actions'
import {
	initApiNode,
	saveApiNode,
	updateApiNode,
} from '@/store/modules/apiNode/actions'
import {
	initFolder,
	saveFolder,
	updateFolder,
} from '@/store/modules/folder/actions'
import {
	initMapping,
	saveMapping,
	updateMapping,
} from '@/store/modules/mapping/actions'
import {
	initQueue,
	saveQueue,
	updateQueue,
} from '@/store/modules/queue/actions'
import {
	initReadMapping,
	saveReadMapping,
	updateReadMapping,
} from '@/store/modules/readMapping/actions'
import {
	initSystem,
	saveSystem,
	updateSystem,
} from '@/store/modules/system/actions'
import {
	initTable,
	saveTable,
	updateTable,
} from '@/store/modules/table/actions'
import { initView, saveView, updateView } from '@/store/modules/view/actions'
import {
	initWorkflow,
	saveWorkflow,
	updateWorkflow,
} from '@/store/modules/workflow/actions'
import {
	initWriteMapping,
	saveWriteMapping,
	updateWriteMapping,
} from '@/store/modules/writeMapping/actions'
import { initDiagram, saveDiagram } from '@/store/slices/diagram/thunks'

export const getStructureTypeActions = (type: StructureObjectDto['type']) => {
	switch (type) {
		case StructureObjectDtoOld.TypeEnum.API_NODE:
			return {
				initData: initApiNode,
				updateData: updateApiNode,
				saveData: saveApiNode,
			}
		case StructureObjectDtoOld.TypeEnum.API_COLLECTION:
			return {
				initData: initApiCollection,
				updateData: updateApiCollection,
				saveData: saveApiCollection,
			}
		case 'DIAGRAM':
			return {
				initData: initDiagram,
				updateData: diagramUpdated,
				saveData: saveDiagram,
			}
		case StructureObjectDtoOld.TypeEnum.FOLDER:
			return {
				initData: initFolder,
				updateData: updateFolder,
				saveData: saveFolder,
			}
		case StructureObjectDtoOld.TypeEnum.MAPPING:
		case StructureObjectDtoOld.TypeEnum.MAPPING_DEFAULT:
			return {
				initData: initMapping,
				updateData: updateMapping,
				saveData: saveMapping,
			}
		case StructureObjectDtoOld.TypeEnum.MAPPING_READ:
			return {
				initData: initReadMapping,
				updateData: updateReadMapping,
				saveData: saveReadMapping,
			}
		case StructureObjectDtoOld.TypeEnum.MAPPING_WRITE:
			return {
				initData: initWriteMapping,
				updateData: updateWriteMapping,
				saveData: saveWriteMapping,
			}
		case StructureObjectDtoOld.TypeEnum.QUEUE:
			return {
				initData: initQueue,
				updateData: updateQueue,
				saveData: saveQueue,
			}
		case StructureObjectDtoOld.TypeEnum.SYSTEM:
			return {
				initData: initSystem,
				updateData: updateSystem,
				saveData: saveSystem,
			}
		case StructureObjectDtoOld.TypeEnum.TABLE:
			return {
				initData: initTable,
				updateData: updateTable,
				saveData: saveTable,
			}

		case StructureObjectDtoOld.TypeEnum.VIEW:
			return {
				initData: initView,
				updateData: updateView,
				saveData: saveView,
			}
		case StructureObjectDtoOld.TypeEnum.WORKFLOW:
			return {
				initData: initWorkflow,
				updateData: updateWorkflow,
				saveData: saveWorkflow,
			}
		case StructureObjectDtoOld.TypeEnum.FOLDER_WORKFLOW:
			return {
				initData: initWorkflow,
				updateData: updateWorkflow,
				saveData: saveWorkflow,
			}

		default:
			console.error('Unknown structure type')

			return {
				initData: initWorkflow,
				updateData: updateWorkflow,
				saveData: saveWorkflow,
			}
	}
}
